import audioTemplate from '/app/templates/audio-template.ejs'
import bubbleTemplate from '/app/templates/bubble-template.ejs'
import channelPicker from '/app/templates/channel-picker.ejs'
import channelPickerFooter from '/app/templates/channel-picker-footer.ejs'
import chatMessageTemplate from '/app/templates/chat-message-template.ejs'
import chatTemplate from '/app/templates/chat-template.ejs'
import collabCallback from '/app/templates/collab-callback.ejs'
import genesysAudio from '/app/templates/genesys-audio.ejs'
import genesysCallback from '/app/templates/genesys-callback.ejs'
import genesysWebMessenger from '/app/templates/genesys-web-messenger.ejs'
import genesysWebMessengerMessage from '/app/templates/genesys-web-messenger-message.ejs'
import popover from '/app/templates/popover.ejs'
import quickReplies from '/app/templates/quickReplies.ejs'
import popup from '/app/templates/popup.ejs'
import callPopover from '/app/templates/callPopover.ejs'
import widgetWindow from '/app/templates/widget-window.ejs'
import chatQuickReplyTemplate from '/app/templates/chat-quick-reply-template.ejs'
import headsUpQuickReplyTemplate from '/app/templates/headsup-quick-reply-template.ejs'
import chatCoBrowseRequestTemplate from '/app/templates/chat-co-browse-request-template.ejs'
import chatCoBrowseControlRequestInfoTemplate from '/app/templates/chat-co-browse-control-request-info-template.ejs'
import whatsapp from '/app/templates/whatsapp-template.ejs'
import facebookMessenger from '/app/templates/facebookMessenger-template.ejs'
import callbackTemplate from '/app/templates/callback-template.ejs'
import genesysVideo from '/app/templates/genesys-video.ejs'
import videoTemplate from '/app/templates/video-template.ejs'
import genesysWebMessengerStatusMessage from '/app/templates/chat-message-status.ejs'
import chatMessageTypingIndicatorTemplate from '/app/templates/chat-message-typing-indicator-template.ejs'
import chatVideoOfferTemplate from '/app/templates/chat-video-offer-template.ejs'
import scheduledVideoTemplate from '/app/templates/scheduled-video-template.ejs'
import genesysFaqTemplate from '/app/templates/genesys-faq/genesys-faq-template.ejs'
import genesysFaqArticleTemplate from '/app/templates/genesys-faq/genesys-faq-article-template.ejs'
import genesysFaqSearchResultsTemplate from '/app/templates/genesys-faq/genesys-faq-search-results-template.ejs'
import chatCarouselTemplate from '/app/templates/chat-carousel-template.ejs'
import formTemplate from '/app/templates/form-template.ejs'
import preInteractionFormTemplate from '/app/templates/pre-interaction-form-template.ejs'

export default {
  audioTemplate,
  bubbleTemplate,
  channelPicker,
  channelPickerFooter,
  chatMessageTemplate,
  chatQuickReplyTemplate,
  headsUpQuickReplyTemplate,
  chatCoBrowseRequestTemplate,
  chatTemplate,
  collabCallback,
  genesysAudio,
  genesysCallback,
  genesysWebMessenger, // not used to be removed
  genesysWebMessengerMessage, // not used to be removed
  popover,
  quickReplies,
  popup,
  callPopover,
  widgetWindow,
  callbackTemplate,
  chatCoBrowseControlRequestInfoTemplate,
  whatsapp,
  facebookMessenger,
  genesysVideo,
  videoTemplate,
  genesysWebMessengerStatusMessage,
  chatMessageTypingIndicatorTemplate,
  chatVideoOfferTemplate,
  scheduledVideoTemplate,
  genesysFaqTemplate,
  genesysFaqArticleTemplate,
  genesysFaqSearchResultsTemplate,
  chatCarouselTemplate,
  formTemplate,
  preInteractionFormTemplate,
}
